var app = app || {};
( function( $ ) {
   $(document).ready(
      function () {
         app.effect.init();
      }
   );
   app.effect = app.effect || {};

   app.effect.init = function(){

      app.effect.initFadeInScroll();
      app.effect.initParallax();

   };
   app.effect.initFadeInScroll = function(){

      //add effect class to h and p
      var bottomOffsetBeforeShow = (app.main.isDesktop()) ? 70 : 30;
      var fadeInScroll = function(){
         var scrollTop = $(window).scrollTop();
         $('.effect-fadein').each(function(){
            var $bg = $(this);
            if ($bg.offset().top - $(window).height() + bottomOffsetBeforeShow < scrollTop) {
               $(this).addClass('active');
            }
         });
         

         $('.effect-slidein').each(function(){
            var $bg = $(this);
            if ($bg.offset().top - $(window).height() + bottomOffsetBeforeShow < scrollTop) {
               $(this).addClass('active');
            }
         });
      }
      $(window).on('scroll app:viewUpdate app:contentLoaded', function(){
         fadeInScroll();
      });
      fadeInScroll();



   };

   app.effect.initParallax = function(){

      var parallaxEffect = function(){
         var scrollTop = $(window).scrollTop();
         var windowHeight = $(window).height();
         $('.js-parallax').each(function(){
            var $parallax = $(this);
            if ($parallax.attr('data-parallax-desktop-only') == 'true' && !app.main.isDesktop()) {
               return true;
            }
            
            var $mover = $parallax.find('.js-parallax-mover');
            if ($mover.length) {
               if ($mover.attr('data-parallax-reverse')=="true") {
                  var displacement = ($parallax.offset().top  - scrollTop - windowHeight/4) / 3;
                  $mover.css({ marginTop: -displacement+'px'});
               }
               else {
                  var displacement = ($parallax.offset().top  - scrollTop - windowHeight/4) / 6;
                  $mover.css({ marginTop: displacement+'px'});
               }
               
               
            }
           
            
         });

      }
      $(window).on('scroll app:viewUpdate app:contentLoaded', function(){
         parallaxEffect();
      });
      parallaxEffect();



   };



})(jQuery);
